import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { Flex, rem } from '@mantine/core';
import React from 'react';
import styled from 'styled-components';

interface IContentObject {
	[key: string]: string | number | React.ReactNode;
}

export interface Props {
	className?: string;
	content?: string[] | IContentObject[];
	status?: React.ReactNode;
	button?: React.ReactNode;
	onClick?: () => void;
}

const ContentInRow = ({ className, content, status, button, onClick }: Props) => {
	return (
		<Flex
			direction="column"
			gap={rem(8)}
			h="100%"
			style={{ overflow: 'auto' }}
			className={className}
		>
			{content && (
				<ContentContainer>
					{content.map((each, index) =>
						typeof each === 'string' ? (
							<Content key={`${each + index}`}>
								<Text variant="sans/14/200" disableVariantMapping>
									{each}
								</Text>
							</Content>
						) : (
							<Content key={`${each.key}-${index}`}>
								{each.key && (
									<KeyText
										capitalizeFirst
										variant="sans/14/200"
										disableVariantMapping
									>
										{each.key}
									</KeyText>
								)}
								<Text
									variant="sans/14/600"
									disableVariantMapping
									className={each.key ? 'add-padding' : ''}
								>
									{each.value}
								</Text>
							</Content>
						)
					)}
				</ContentContainer>
			)}
			{button && <ButtonContainer onClick={onClick}>{button}</ButtonContainer>}
			{status && <ButtonContainer>{status}</ButtonContainer>}
		</Flex>
	);
};

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: row;
	::-webkit-scrollbar {
		width: 0.125em;
		height: 0.5em;
	}
	::-webkit-scrollbar-thumb {
		height: 2em;
		background-color: ${({ theme }) => theme.v2.color.neutral['400']};
	}
`;

export const ButtonContainer = styled.div`
	margin-top: auto;
	display: flex;
`;

export const Content = styled.div`
	display: inline-block;
	flex-direction: row;
	padding-right: ${rem(4)};

	:last-child {
		padding-right: ${rem(12)};
	}

	:not(:last-child) {
		border-right: 1px solid ${({ theme }) => theme.v2.color.neutral[900]};
		padding-right: ${rem(5)};
		margin-right: ${rem(5)};
	}

	color: ${({ theme }) => theme.v2.color.neutral[300]};

	.add-padding {
		padding-left: ${rem(4)};
	}
`;

const KeyText = styled(Text)`
	color: ${({ theme }) => theme.v2.color.neutral[300]};
`;
export const MiddleContent = styled(ContentInRow)``;
